import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const ApplicantManagementHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Applicant Management
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Streamline your applicant review and management process with our comprehensive tools.
            Efficiently track, evaluate, and communicate with candidates throughout the hiring journey.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Application Review
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Review applications efficiently with our intuitive interface. Access candidate resumes,
            cover letters, and application details in one centralized location.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Candidate Communication
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Maintain clear communication with candidates through our integrated messaging system.
            Send updates, schedule interviews, and provide feedback all in one place.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Application Status Tracking
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Track the status of each application through your customized hiring pipeline. Move candidates
            between stages and maintain visibility of your entire recruitment process.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Team Collaboration
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Collaborate with your hiring team by sharing notes, ratings, and feedback on candidates.
            Make informed decisions together with our collaborative tools.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/applicants"
              color="primary"
              variant="contained"
            >
              Manage Applicants
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default ApplicantManagementHelp; 